/**
 * @link https://mui.com/material-ui/react-autocomplete/
 */

import {Autocomplete, TextField} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

/**
 * Set Some default Props
 */
const options = [
    { label: '1.0037 | S235JRC+C | St37k', id: 1 },
    { label: '1.0503 | C45', id: 2 },
    { label: '1.4301 | V2A', id: 3 },
    { label: '1.7131 | 16MnCr5', id: 4 },
]

export default function FactureeAutocomplete() {
  return (
    <>
      <Autocomplete
        disablePortal
        options={options}
        sx={{width: 300}}
        renderInput={(params) => <TextField {...params} label="Select material" />}
      />

      <Autocomplete
        disablePortal
        options={options}
        sx={{width: 300}}
        renderInput={(params) => <TextField {...params} label="Select material" variant="filled" margin="normal" />}
      />

      <Autocomplete
        disablePortal
        options={options}
        sx={{width: 300}}
        renderInput={(params) => <TextField {...params} label="Select material" variant="standard" margin="normal" />}
      />
      <p>&nbsp;</p>
      
      <ShowCode 
        codeString={`<>
  {/* Basic Autocomplete with default variant */}
  <Autocomplete
    disablePortal
    options={[
      { label: '1.0037 | S235JRC+C | St37k', id: 1 },
      { label: '1.0503 | C45', id: 2 },
      { label: '1.4301 | V2A', id: 3 },
      { label: '1.7131 | 16MnCr5', id: 4 },
    ]}
    sx={{ width: 300 }}
    renderInput={(params) => <TextField {...params} label="Select material" />}
  />
  
  {/* Autocomplete with filled variant */}
  <Autocomplete
    disablePortal
    options={[
      { label: '1.0037 | S235JRC+C | St37k', id: 1 },
      { label: '1.0503 | C45', id: 2 },
      { label: '1.4301 | V2A', id: 3 },
      { label: '1.7131 | 16MnCr5', id: 4 },
    ]}
    sx={{ width: 300 }}
    renderInput={(params) => <TextField {...params} label="Select material" variant="filled" margin="normal" />}
  />
  
  {/* Autocomplete with standard variant */}
  <Autocomplete
    disablePortal
    options={[
      { label: '1.0037 | S235JRC+C | St37k', id: 1 },
      { label: '1.0503 | C45', id: 2 },
      { label: '1.4301 | V2A', id: 3 },
      { label: '1.7131 | 16MnCr5', id: 4 },
    ]}
    sx={{ width: 300 }}
    renderInput={(params) => <TextField {...params} label="Select material" variant="standard" margin="normal" />}
  />
</>`} 
        scope={{ React, Autocomplete, TextField }} 
      />
    </>
  )
}